<template>
  <tea-main @back="goBack">
    <template slot="nav">
      <div class="recordNav">
        <p v-if="classFeedback.feedback_type === 'complaint'">行为投诉详情</p>
        <p v-else-if="classFeedback.feedback_type === 'appeal'">成绩申诉详情</p>
        <p v-else>情况/事件反馈</p>
        <div style="display:flex;" >
          <el-button type="primary" @click="lookHandle" v-if="handleInfoId">查看反馈</el-button>
          <template v-if="['super','system'].includes(member_type)">
            <el-button type="primary" @click="addFunc" v-if="!handleInfoId && !classFeedback.is_handle">反馈（短信通知学员）</el-button>
            <el-button type="info" disabled v-if="classFeedback.is_handle === 1">已处理（仅内部标识）</el-button>
            <el-button type="primary" @click="backComfim=true" v-else>已处理（仅内部标识）</el-button>
          </template>
        </div>
      </div>
    </template>
    <template slot="main">
      <div class="recordMain">
        <yioks-loading v-show="loading"></yioks-loading>
        <div v-if="!loading" class="Info">
          <vue-scroll :ops="ops" ref="vs">
            <div
              class="mainInfo"
              v-if="true"
            >
              <template >
                <div class="title" style="justify-content: space-between">
                  <div style="display: flex;align-items: center;">
                      <v-icon class="logo" name="user" scale="1.6"></v-icon>
                      <p class="titleInfo">
                        基本信息
                      </p>
                  </div>
                  <div class="btns_box" v-if="['super','system','viewer'].includes(member_type)">
                    <span class="zuxie-btn spceial_btn" @click="addFuncDocument" v-if="!['viewer','viewFive'].includes(member_type)">添加文件存档</span>
                    <span  class="zuxie-btn spceial_btn" v-if="isDocumentExit" @click="viewDocuments">
                      查看文件存档
                   </span>
                  </div>
                </div>
                <div class="perInfo">
                  <template>
                    <el-row class="score-row">
                      <el-col :span="8" class="score-col">
                        <p>姓名：{{ userMap.name }}</p>
                      </el-col>
                      <el-col :span="8" class="score-col">
                        <p>手机号：{{ userMap.mobile_phone }}</p>
                      </el-col>
                      <el-col :span="8" class="score-col">
                        <p>状态：{{ classFeedback.is_handle| feedStatus(classFeedback.create_time) }}</p>
                      </el-col>
                    </el-row>
                    <el-row class="score-row">
                      <el-col :span="24" class="score-col">
                        <p><span v-if="classFeedback.feedback_type === 'complaint'">投诉对象：</span>
                        <span v-else-if="classFeedback.feedback_type === 'appeal'">申诉对象：</span>
                          <span v-else>反馈对象：</span>
                          <span v-if="classFeedback.feedback_type === 'complaint' || classFeedback.other_feedback_type === 'complaint'">{{ classFeedback.feedback_obj | experienceFilter1}}</span>
                          <span v-else>{{ classFeedback.feedback_obj | experienceFilter2}}</span></p>
                      </el-col>
                    </el-row>
                    <el-row class="score-row">
                      <el-col :span="24" class="score-col">
                        <p><span v-if="classFeedback.feedback_type === 'complaint'"  style="width: 80px;">投诉内容：</span>
                        <span v-else-if="classFeedback.feedback_type === 'appeal'"  style="width: 80px;">申诉内容：</span>
                          <span v-else  style="width: 80px;">反馈内容：</span>
                          <span>{{ classFeedback.feedback_info || '--'}}</span></p>
                      </el-col>
                    </el-row>
                  </template>
                </div>
              </template>
              
              <template v-if="classFeedback.feedback_type !== 'other'">
                <div class="title">
                  <v-icon
                    class="logo"
                    name="regular/address-book"
                    scale="1.6"
                  ></v-icon>
                  <p class="titleInfo"  v-if="classFeedback.feedback_type === 'complaint'">签署投诉证明文件</p>
                  <p class="titleInfo"  v-else>签署申诉证明文件</p>
                </div>
                <div
                  class="recordInfo"
                >
                  <el-row class="score-row">
                    <el-col :span="24" class="score-col">
                      <template >
                        <p>
                          证明文件：
                          <span  style="color: #4cd964"
                          ><a :href="classFeedback.document_address" target="_blank">
                    <span class="content suc">{{classFeedback.document_title}}</span>
                  </a>
                        </span>
                        </p>
                      </template>
    
                    </el-col>
  
                  </el-row>
                  
                </div>
              </template>
              <template>
                <div class="title">
                  <v-icon
                    class="logo"
                    name="regular/address-book"
                    scale="1.6"
                  ></v-icon>
                  <p class="titleInfo" >相关证明材料</p>
                </div>
                <div
                  class="recordInfo"
                >
                  <el-row class="score-row">
                    <el-col :span="24" class="score-col">
                      <template v-for="(item, index) in ClassFeedbackDocument">
                        <p>
                          证明材料{{index+1}}：
                          <span  style="color: #4cd964"
                          ><a :href="item.document_address" target="_blank">
                      <span class="content suc">{{item.document_title}}</span>
                    </a>
                        </span>
                        </p>
                      </template>
                    </el-col>
                  </el-row>
    
                </div>
              </template>
            </div>
            <div v-else>
              <yioks-empty
                tips="数据不存在，请返回上一步重新查询。"
              ></yioks-empty>
            </div>
            <template v-if="add_show">
              <add-dialog :showAddDialog="add_show" :Info="{feedback_id:classFeedback.feedback_id}" @hideTips="hideAddDocumentTips"></add-dialog>
            </template>
            <div v-if="t_show">
              <details-dialog
                :isShowAddDialog.sync="t_show"
                :dialogData="{feedback_id:classFeedback.feedback_id,handleInfoId:handleInfoId}"
              />
            </div>
            <yioks-tips :showTips="backComfim" tips="请确定该申诉/投诉已处理完毕？" @hideTips="backComfimDialog"></yioks-tips>
            <template v-if="add_showDocument">
              <add-dialog-document :showAddDialog="add_showDocument" :Info="{name:userMap.name,id_number:userMap.id_number,mobile_phone:userMap.mobile_phone,object_type:'student'}" @hideTips="hideAddTips"></add-dialog-document>
            </template>
          </vue-scroll>
        </div>
      </div>
    </template>
  </tea-main>
</template>

<script>
import classSrc from "@/assets/images/class_logo.png";
import {viewPunishInfo} from "@/api/agency/agency";
import { storageData } from "@/assets/js/storage";
import ops from "@/assets/js/vuescrollOption";
import "vue-awesome/icons/user";
import "vue-awesome/icons/regular/address-book";
import "vue-awesome/icons/tags.js";
import "vue-awesome/icons/regular/clock";
import identify1 from "@/assets/images/vita/identify1.png";
import identify2 from "@/assets/images/vita/identify2.png";
import placePhoto from "@/assets/images/person.png";
import fiveMixins from "@/minix/fiveMixins";
import {experienceFilter1,experienceFilter2} from "@/assets/js/yioksFilters";
import {findFeedbackDetails,findFeedbackHandle} from "@/api/system_manager/api";
import { getDocumentList } from '@/api/document/document';

export default {
  name: "feedbackInfo",
  mixins: [fiveMixins],
  data() {
    return {
      identify1,
      identify2,
      placePhoto,
      classSrc,
      feedback_id: this.$route.query.feedback_id,
      userMap:{},
      classFeedback:{},
      ClassFeedbackDocument:[],
      ops: ops(),
      loading: true,
      add_show: false,
      add_showDocument: false,
      t_show: false,
      backComfim: false,
      isDocumentExit: false,
      handleInfoId: 0,
    };
  },
  computed: {
  
  },
  created() {
    const member_type = storageData.getUserInfo().member_type;
    const token = storageData.getToken();
    this.member_type = member_type;
    this.getInfo();
  },
  methods: {
  
    getInfo(){
      findFeedbackDetails(this.feedback_id)
      .then(({data}) => {
        if(data.status === 0){
          const {ClassFeedbackDocument, classFeedback,userMap,handleInfoId} = data.result;
          this.ClassFeedbackDocument = ClassFeedbackDocument;
          this.classFeedback = classFeedback;
          this.userMap = userMap;
          this.handleInfoId = handleInfoId;
          if(['super','system','viewer'].includes(this.member_type)){
            this.checkDocumentExit();
          }
          this.loading = false;
        }else{
          this.$message.error(data.msg);
        }
        
      })
      .catch((err) => {
        console.error("err", err);
        this.loading = false;
      });
    },
    backComfimDialog(bool, sure) {
      if (sure) {
        this.handleRecord();
      }
      this.backComfim = bool;
    },
    handleRecord(){
      findFeedbackHandle({feedback_id:this.feedback_id}).then(({data}) => {
        if (data.status === 0) {
          this.$message.success("已处理成功");
          this.getInfo();
        }else{
          this.$message.error(data.msg);
        }
      })
      .catch((err) => {
        console.error("err", err);
      });
    },
    addFunc() {
      this.add_show = true
    },
    lookHandle(){
      this.t_show = true
    },
    goBack() {
      this.$router.go(-1);
    },
    
    imgListErr(idx) {
      this.$set(this.list[idx], "moment_picture", this.imgSrc);
    },
  
    addFuncDocument() {
      this.add_showDocument = true
    },
    
    
    imgError(type) {
      if (type === "photo") {
        this.$set(this.recordInfo, "profile_picture", this.placePhoto);
      } else if (type === "front") {
        this.$set(this.recordInfo, "id_card_photo_front", this.identify1);
      } else if (type === "verson") {
        this.$set(this.recordInfo, "id_card_photo_verso", this.identify2);
      }
    },
    hideAddDocumentTips(bool,flag){
      this.add_show = bool;
      if (flag){
        this.$message.success('反馈成功！')
        this.getInfo();
      }
    },
    hideAddTips(bool,flag){
      this.add_showDocument = bool;
      if (flag){
        this.$message.success('添加成功！');
        this.checkDocumentExit();
      }
    },
    // 检查文件存档是否存在
    checkDocumentExit() {
      const params = {
        page: 1,
        keywords: '',
        id_number: this.userMap.id_number,
        object_type: '',  // class organ
      };
      getDocumentList(params).then(({ data })=> {
        if(data.status === 0){
          const { page } = data.result;
          if(page.total_row) {
          
            this.isDocumentExit = true;
          }else {
          
            this.isDocumentExit = false
          }
        } else {
          console.error('getDocumentList request error')
        }
      }).catch(err =>{
        console.log('err',err)
      })
    },
    viewDocuments(){
      this.$router.push({
        path: "documents",
        query: {
          id_number:this.userMap.id_number
        }
      });
    },
  },
  filters: {
    experienceFilter1,
    experienceFilter2,
    feedStatus(handle,time){
      var status = "已完结";
      if(handle === 0){
        status = "提交成功";
        const last= time + 60*60*1000
        if(new Date().getTime() > last){
          status = "已受理";
        }
      }
      return status;
    },
  },

  components: {
    "tea-main": () => import("@/components/LayOut/Common/up-down"),
    "yioks-empty": () => import("@/components/Tips/Empty"),
    "v-icon": () => import("vue-awesome/components/Icon"),
    "yioks-loading": () => import("@/components/Loading/Loading"),
    "add-dialog": () => import('../components/AddDialog'),
    "add-dialog-document": () => import('@/views/Documents/components/AddDialog'),
    "details-dialog": () => import("../components/SeeHandleDetails"),
    "yioks-tips": () => import('@/components/Tips/Dialog'),
  },
};
</script>

<style scoped lang="stylus">
@import '~@/assets/css/variable'
@import '~@/assets/css/mixin'
@import '~@/assets/css/nav_filter'
.recordNav, .recordMain
  flex 1 1 auto
  height 100%
.recordNav
  display flex
  justify-content space-between
  align-items center
  padding 0 12px 0 0
  font-size $font_size_big
  .audit
    display flex
    justify-content center
    align-items center
    padding 5px 15px
    font-size 16px
    background-color $color_suc
    cursor pointer
.recordMain
  width 100%
  padding 25px 0 25px 0
  background-color $block_bg_color_base
  .Info
    padding 0 0 0 40px
    height 550px
    .mainInfo
      padding-right 40px
      padding-top 5px
      .zuxie-btn
        background-color $color_suc
        width 80px
        padding 10px 4px
        
      .perInfo, .recordInfo
        position relative
        margin-bottom 40px
        border 1px solid $color_white
        .score-row
          border-bottom 1px solid $color_white
          .score-table
            .row
              border-bottom 1px solid $color_white
              display flex
              &:last-child
                border-bottom none
              .score-col
                
                border-left 1px solid $color_white
                flex auto
                &:first-child
                  border-left none
                p
                  margin 10px
                  font-size $font_size_medium
                  word-break break-all
                  &.score-note
                    text-align left
          &:last-child
            border-bottom none
          .score-col
            
            border-left 1px solid $color_white
            &:first-child
              border-left none
            p
              margin 10px
              font-size $font_size_medium
              word-break break-all
              &.score-note
                text-align left
        .dashed-line
          width 100%
          position absolute
          bottom -22px
          left 0
          border 1px dashed $color_white
        &:last-child
          margin-bottom 0
      
      .title
        display flex
        margin-bottom 10px
        .titleInfo
          margin-left 10px
          font-size 18px
          line-height 1.6
        .btns_box{
          .zuxie-btn{
            background none;
            border 1px solid;
            width: 115px;
            &:last-child{
              margin 0 0 6px 8px;
            }
            &.complete{
              width 100%
              margin-left 0
            }
            &:hover{
              background $color_primary;
            }
          }
          .spceial_btn{
            width 115px
            height 38px
            line-height: 38px;
            text-align center
            padding 0
          }
        }
      .timeline
        display block
        padding-left 3px
        .timeline-item
          position relative
          padding-bottom 20px
          .item_tail
            position absolute
            top 36px
            bottom 6px
            left 16px
            // height 100%
            border-left 2px solid #cccccc
          .item_node
            position absolute
            background-color #fff
            color #333
            border 1px solid #fff
            border-radius 50%
            // left -2px
            width 36px
            height @width
            font-size 12px
            display flex
            align-items center
            text-align center
            justify-content center
          .item_wrap
            position relative
            padding-left 50px
            top -3px
            .timestamp
              display flex
              // align-items center
              line-height 1
              margin-bottom 5px
              font-size 15px
              .audit_people
                flex 1
                text-align right
                margin-left 10px
            .item_cont
              display block
              background-color #fff
              color #333
              padding 10px
              border-radius 4px
              border 1px solid #cccccc
              overflow hidden
              font-size 15px
              box-shadow 0 2px 12px 0 rgba(255, 255, 255, 0.1)
      .intro_data
        border 1px dashed $color_white
        padding-left 370px
        height 12px
        font-size 16px
        margin-bottom 20px
      .el-tag + .el-tag
        margin-left 10px
      .button-new-tag
        margin-left 10px
        height 32px
        line-height 30px
        padding-top 0
        padding-bottom 0
      .input-new-tag
        width 90px
        margin-left 10px
        vertical-align bottom
</style>
<style lang="stylus">
.tag_tag
  height auto
  white-space normal
</style>
